import { Container, Divider, Grid, IconButton, MenuItem, TextField, Tooltip } from '@material-ui/core'
import React, { useEffect, useState } from 'react'
import FlexView from 'react-flexview/lib'
import { useForm, Controller } from 'react-hook-form'
import adminApi from '../../api/admin.api'
import { EventEmitterService, EventKey } from '../../services/EventEmitterService'
import { awaitWithLoading } from '../../services/utils'
import NewFillButton from '../Core/NewFillButton'
import { ProfilePicturePopover } from '../Core/Popover/ProfilePicturePopover'
import { SkyElementHoverPopover } from '../Core/Popover/SkyPopover'
import { ReactComponent as CompanyLogoSvg } from '../../assets/company-logo.svg'
import { ReactComponent as CameraIconSvg } from '../../assets/camera_add.svg'
import { ReactComponent as CameraChangeSvg } from '../../assets/change-photo.svg'
import './CreatePartnershipForm.scss'
import { ContactSupportOutlined, ErrorSharp, SignalCellularNoSimOutlined } from '@material-ui/icons'
import { EMAIL_REGEX } from '../../Constants'
import { ElevatedCircle } from '../Core/ElevatedCircle'
import AddAPhotoIcon from '@material-ui/icons/AddAPhoto'
import Resizer from 'react-image-file-resizer'
import { useHistory } from 'react-router-dom'
import { AdminContextStore } from './AdminContext'
import FirebaseDatabaseService from '../../services/FirebaseDatabaseService'
import { useParams } from 'react-router-dom/cjs/react-router-dom'


export const EditPartnershipForm = () => {
  const history = useHistory()
  const adminContext = React.useContext(AdminContextStore)
  const {agencyId} = useParams();
  const [selectedAgency, setSelectedAgency] = useState(null);
  const { register, errors, getValues, setValue, watch, control, triggerValidation, reset } = useForm({ mode: 'onChange',
  defaultValues: {
    theme_key: selectedAgency?.code,
    partnership_name: selectedAgency?.name,
    logo: selectedAgency?.logo, 
    contact_email: selectedAgency?.contact_email,
    affiliation_code:selectedAgency?.affiliation_code.code,
    description:selectedAgency?.description,
    network_id:selectedAgency?.partnership_network_id? selectedAgency?.partnership_network_id: 0,
    first_policy_commission: selectedAgency?.first_policy_commission ?? "default",
    renewal_commission:selectedAgency?.renewal_commission ?? "default",
    id:selectedAgency?.id,
  },})
  const id=watch("id")
  const theme_key= watch("theme_key")
  const logo_url=`${process.env.REACT_APP_S3_BUCKET_URL}broker-logos/logos/${theme_key}_logo.png`
  const favicon_url= `${process.env.REACT_APP_S3_BUCKET_URL}broker-logos/favicons/${theme_key}_favicon.ico`
  const [img, setImg] = React.useState(logo_url)
  const [favicon, setFavicon] = React.useState(favicon_url)
  const profilePicture = React.useRef(img)
  const faviconPicture = React.useRef(favicon)

  useEffect(() => {
    if(adminContext.agencies.length === 0) return;
    const agency = adminContext.agencies.find(a => a.id == agencyId);
    if(!agency) return;
    setSelectedAgency(agency);
    reset({
      theme_key: agency.code,
      partnership_name: agency.name,
      logo: agency.logo, 
      contact_email: agency.contact_email,
      affiliation_code:agency.affiliation_code.code,
      description:agency.description,
      network_id:agency.partnership_network_id ? agency.partnership_network_id : 0,
      first_policy_commission: agency.first_policy_commission,
      renewal_commission:agency.renewal_commission + "",
      id:agency?.id,
    })
  },[adminContext.agencies])
  
  const resizeFile = file =>
    new Promise(resolve => {
      Resizer.imageFileResizer(
        file,
        240,
        160,
        'PNG',
        100,
        0,
        uri => {
          resolve(uri)
        },
        'file'
      )
    })

    useEffect(() => {
      if(!selectedAgency) return;

      const logo_url=`${process.env.REACT_APP_S3_BUCKET_URL}broker-logos/logos/${selectedAgency.code}_logo.png`
      const favicon_url= `${process.env.REACT_APP_S3_BUCKET_URL}broker-logos/favicons/${selectedAgency.code}_favicon.ico`
      setImg(logo_url)
      setFavicon(favicon_url)

      FirebaseDatabaseService.getSnapshotData('theme', selectedAgency.code).then((color)=> 
      {
        setValue('theme_blue', color.blue)
      })
    },[setValue, selectedAgency])
  

    const onProfilePictureSelected = async event => {
    const file = event.target.files[0]
    const image = await resizeFile(file)
    setImg(URL.createObjectURL(image))
    setValue('logo', image)
  }

  const onFaviconSelected = async event => {
    setFavicon(URL.createObjectURL(event.target.files[0]))
    setValue('favicon', event.target.files[0])
  }

  const uploadProfilePicture = () => profilePicture.current.click()
  const uploadFavicon = () => faviconPicture.current.click()

  const submit = async () => {
    const valid = await triggerValidation()

    if (!valid) return

    var form = getValues()
    form.redeem_code = getValues()['affiliation_code']
    form.partnership_code = getValues()['theme_key']
    form.id=id
    let res = await awaitWithLoading(adminApi.editAgency(form))
    if (res.ok) {
      EventEmitterService.dispatch(EventKey.ShowSuccess, {
        title: 'Agency Changed!',
        body: 'The agency has been changed, you can now edit agents to that agency',
        onClose: () => {
          history.push('/broker/admin/agencies')
          awaitWithLoading(adminContext.loadAgencies())
        },
      })
    } else EventEmitterService.dispatch(EventKey.ShowError, res)
  }

  React.useEffect(() => {
    register('logo' )
    register('favicon')
  }, [register])

  return (
    <Container className="margin-top-basic">
      <div className="text-promotion black bold">Create New Partnership</div>

      <br />

      <br />
      <div className="text-title blue bold">Agency Details</div>
      <Divider />
      <br />

      <FlexView>
        <div>
          <div className="company-logo-container-2 margin-right-basic clickable" onClick={uploadProfilePicture}>
            {!img ? (
              <React.Fragment>
                <CompanyLogoSvg />
                <div className="company-logo-text-2 gray bold text-body">Company Logo</div>
              </React.Fragment>
            ) : (
              <img className="company-logo-img" src={img} />
            )}
            {/* </SkyElementHoverPopover> */}
            <input
              type="file"
              accept="image/*"
              id="file"
              onChange={onProfilePictureSelected}
              ref={profilePicture}
              style={{ display: 'none' }}
            />
            <div className="camera-box clickable">{!img ? <CameraIconSvg /> : <CameraChangeSvg />}</div>
          </div>
          <br />
          <ElevatedCircle>
            {!favicon && (
              <Tooltip title={'Favicon'} placement="top">
                <IconButton onClick={uploadFavicon}>
                  <AddAPhotoIcon />
                </IconButton>
              </Tooltip>
            )}
            {favicon && <img onClick={uploadFavicon} className="clickable favicon-logo-img" src={favicon} />}
          </ElevatedCircle>
          <input type="file" accept="image/*" id="file" onChange={onFaviconSelected} ref={faviconPicture} style={{ display: 'none' }} />
        </div>

        <Grid container spacing={2} direction="column" justifyContent="space-between">
          <Grid container spacing={3}>
            <Grid item xs={12} sm={4}>
              <TextField
                inputRef={register({ required: true })}
                name="partnership_name"
                label={'Agency Name'}
                InputLabelProps={{ shrink: true }}
                error={!!errors.partnership_name}
                helperText={!!errors.partnership_name ? 'required' : "Agency's name to identify"}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                inputRef={register({ required: true })}
                name="affiliation_code"
                label={'Affiliation Code'}
                InputLabelProps={{ shrink: true }}
                error={!!errors.affiliation_code}
                helperText={!!errors.affiliation_code ? 'required' : 'For example: VOOOM2021, AJG2020'}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Controller
                control={control}
                rules={{ required: true }}
                name="network_id"
                as={
                  <TextField
                    label="Network"
                    error={!!errors.network}
                    helperText={!!errors.network ? 'required' : ''}
                    fullWidth
                    select
                    variant="outlined"
                  >
                    <MenuItem value={0}>None</MenuItem>
                    {adminContext.networks.map(network => (
                      <MenuItem key={network.id} value={network.id}>
                        {network.name}
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} className="question_container">
            <Grid item xs={12} sm={4}>
              <TextField
                inputRef={register({ required: true })}
                name="description"
                label={'Description'}
                InputLabelProps={{ shrink: true }}
                error={!!errors.description}
                helperText={!!errors.description ? 'required' : 'For example: Gallagher Drone Insurance powered by SkyWatch.AI'}
                fullWidth
                variant="outlined"
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <TextField
                name="contact_email"
                label={'Contact Email'}
                InputLabelProps={{ shrink: true }}
                error={!!errors.contact_email}
                fullWidth
                variant="outlined"
                type="email"
                inputRef={register({ required: true, pattern: { value: EMAIL_REGEX, message: 'Invalid email address' } })}
                helperText={!!errors.contact_email && (errors.contact_email.message || errors.contact_email.type)}
              />
            </Grid>
          </Grid>
          <Grid container spacing={3} className="question_container">
            <Grid item xs={12} sm={4}>
              <Controller
                control={control}
                rules={{ required: true }}
                name="first_policy_commission"
                as={
                  <TextField
                    label="New Business Commission"
                    error={!!errors.first_policy_commission}
                    helperText={!!errors.first_policy_commission ? 'required' : ''}
                    fullWidth
                    select
                    variant="outlined"
                  >
                      <MenuItem value="default" disabled>
                        None
                      </MenuItem>
                    {adminContext.commissions && adminContext.commissions.first_policy_commission && adminContext.commissions.first_policy_commission.map((commission, id) => (
                      <MenuItem key={id} value={commission}>
                        {Math.round(commission * 100)}%
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </Grid>
            <Grid item xs={12} sm={4}>
              <Controller
                control={control}
                rules={{ required: true }}
                name="renewal_commission"
                as={
                  <TextField
                    label="Renewal Commission"
                    error={!!errors.renewal_commission}
                    helperText={!!errors.renewal_commission ? 'required' : ''}
                    fullWidth
                    select
                    variant="outlined"
                  >
                    <MenuItem value="default" disabled>
                      None
                    </MenuItem>
                    {adminContext.commissions && adminContext.commissions.renewal_commission && adminContext.commissions.renewal_commission.map((commission) => (
                      <MenuItem key={commission} value={commission}>
                        {Math.round(commission * 100)}%
                      </MenuItem>
                    ))}
                  </TextField>
                }
              />
            </Grid>
          </Grid>
        </Grid>
      </FlexView>
      <br />
      <div className="text-title blue bold">Agency Theme</div>
      <Divider />
      <br />
      <Grid container spacing={3}>
        <Grid item xs={12} sm={4}>
          <TextField
            inputRef={register({ required: true })}
            name="theme_key"
            label={'Domain Prefix'}
            InputLabelProps={{ shrink: true }}
            error={!!errors.theme_key}
            helperText={!!errors.theme_key ? 'required' : "Broker's name that will appear in the URL"}
            fullWidth
            variant="outlined"
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <TextField
            inputRef={register({ required: true, validate: k => k.startsWith('#'), minLength: 7, maxLength: 7 })}
            name="theme_blue"
            label={'Theme Color'}
            InputLabelProps={{ shrink: true }}
            error={!!errors.theme_blue}
            helperText={
              !!errors.theme_blue
                ? (errors.theme_blue.type == 'required' && 'required') ||
                  ((errors.theme_blue.type == 'validate' ||
                    errors.theme_blue.type == 'minLength' ||
                    errors.theme_blue.type == 'maxLength') &&
                    'Must start with # and have 6 english letters')
                : 'Theme main color, for example: #abbcas'
            }
            fullWidth
            variant="outlined"
          />
        </Grid>
      </Grid>
      <FlexView hAlignContent="left">
        <NewFillButton onClick={submit} flat green>
          Submit
        </NewFillButton>
      </FlexView>
    </Container>
  )
}
